<script>
  export let label = '';
  export let items = [];
  export let slug = label.toLowerCase();
  export let selected = [];
</script>

<fieldset class="filter-group">
  <legend class="filter-heading">
    <button class="filter-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#{slug}-filter" aria-expanded="false" aria-controls="{slug}-filter">
      Sort by {label}
    </button>
  </legend>

  <div class="filter-collapse collapse" id="{slug}-filter">
    <div class="filter-list">
      {#each items as {title, id} (id)}
        <div class="filter-check">
          <input class="filter-input" type="checkbox" bind:group={selected} value={id} id="{slug}-input-{id}">
          <label class="filter-label" for="{slug}-input-{id}">
            {title}
          </label>
        </div>
      {/each}
    </div>
  </div>
</fieldset>
